module.exports = __webpack_public_path__ + "1792771649312/fonts/Rubik-Light.36b5622.ttf";